<template>
  <BaseGridView
    endpoint="v1/GeneralLedgerAccount/GetData"
    :pageTitle="$t('General Ledger Accounts')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #general_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge badge-success' : 'badge badge-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const templateDef: TemplateDef = {
  prefix: "general",
  columnNames: ["isActive"],
};
const _searchOptions = {
  fields: [
    "company.Name",
    "name",
    "accountNo",
    "currencyCode",
    "departmentCode",
    "lastChangedDateTimeOffset",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    {
      field: "name",
      headerText: instance?.$t("name"),
      type: "text",
    },
    {
      field: "accountNo",
      headerText: instance?.$t("accountNo"),
      type: "text",
    },
    {
      field: "currencyCode",
      headerText: instance?.$t("currencyCode"),
      type: "text",
    },
    {
      field: "departmentCode",
      headerText: instance?.$t("departmentCode"),
      type: "text",
    },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "general_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
  ];
};
</script>
